import React, { useEffect } from "react";
import { useFocusWrapper } from "../../../../../hooks/useFocusWrapper";
function Slide(_ref) {
  var children = _ref.children;
  var _useFocusWrapper = useFocusWrapper(),
    focusWrapperRef = _useFocusWrapper.focusWrapperRef,
    handleOnFocusWrapper = _useFocusWrapper.handleOnFocusWrapper,
    handleOnBlurWrapper = _useFocusWrapper.handleOnBlurWrapper;
  useEffect(function () {
    var _focusWrapperRef$curr;
    var sectionLinkElement = (_focusWrapperRef$curr = focusWrapperRef.current) === null || _focusWrapperRef$curr === void 0 ? void 0 : _focusWrapperRef$curr.querySelector("a[data-section-link]");
    if (sectionLinkElement) {
      sectionLinkElement.setAttribute("tabindex", "-1");
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: focusWrapperRef,
    onFocus: handleOnFocusWrapper,
    onBlur: handleOnBlurWrapper,
    tabIndex: 0,
    className: "focusable-slide-wrapper"
  }, children);
}
export default Slide;